import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

import { NavItem } from '../../interfaces/nav-item';
import { MenuListItemComponent } from '../../molecules/menu-list-item/menu-list-item.component';

@Component({
  selector: 'locumsnest-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuListItemComponent],
})
export class SideNavBarComponent {
  readonly idx = input.required<string>();
  readonly itemList = input.required<NavItem[]>();
  readonly nestPanelExpanded = input.required<boolean>();
  readonly filterCount = input.required<number>();
  readonly activeNavItem = input.required<string | null>();
  readonly filtersDisabled = input.required<boolean>();
  readonly hospitalOfficerPath = input.required<string>();
  readonly isAgencyPlatform = input.required<boolean>();
  readonly showMessagingPanel = input.required<boolean>();
  readonly hasUnreadMessages = input.required<boolean>();

  readonly toggled = output<void>();
  readonly clicked = output<void>();
  readonly expanded = output<boolean>();
  readonly filterMenuClicked = output<void>();
  readonly messagingMenuClicked = output<void>();

  readonly menuExpanded = signal(false);

  onMenuExpanded() {
    this.menuExpanded.update((expanded) => !expanded);
    this.expanded.emit(this.menuExpanded());
  }
}
